import { FC } from 'react'

import { cn } from '@/app/utils'

import EmptyNotificationSvg from '../assets/EmptyNotification.svg'

type Props = {
  className?: string
}

const NotificationEmptyMessage: FC<Props> = ({ className }) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-20 text-center',
        className
      )}
    >
      <EmptyNotificationSvg />

      <div className="mt-24 font-bold text-grey-80 text-16">
        Новых уведомлений нет
      </div>
    </div>
  )
}

export default NotificationEmptyMessage
